<div class="headerFlexW pr-4 m-3">
  <div class="content-block">
    <p class="bread-crumbs">Programas</p>
    <h2 class="">Programas</h2>
  </div>
  <dx-button text="Nuevo programa" icon="plus" type="default" (onClick)="addProgram()"></dx-button>
</div>
<div class="dx-card content-block">
  <div class="responsive-paddings">
    <dx-data-grid [dataSource]="programsList" keyExpr="id" [allowColumnReordering]="true"
      [masterDetail]="{ enabled: true, template: 'detail' }" showBorders="true" class="programGrid">
      <dxi-column dataField="name" caption="Nombre" alignment="center"></dxi-column>
      <dxi-column dataField="startDate" caption="Inicia" cellTemplate="dateTemplate"  alignment="center"></dxi-column>
      <dxi-column dataField="endDate" caption="Expira" cellTemplate="dateTemplate"  alignment="center"></dxi-column>
      <dxi-column dataField="dateCreated" caption="Creado" cellTemplate="dateTemplate"  alignment="center"></dxi-column>
      <dxi-column dataField="id" type="buttons" cellTemplate="btnTemplate" caption=""  alignment="center"></dxi-column>
      <div *dxTemplate="let myDate of 'dateTemplate'">
        {{myDate.value|numberToDate}}.
      </div>
      <div *dxTemplate="let p of 'detail'">
        <div class="flex flex-nowrap details-templateW  datagrid-detailsW flex-space-around">
          <div class="mr-5">
            <h2>Datos generales</h2>
            <ul class="list-no-style">
              <li><strong> Nombre:</strong> {{p.data.name}}</li>
              <!-- <li><strong> Tarjeta:</strong> {{p.data.cardTypeName}}</li> -->
              <li><strong> Vigencia:</strong> {{p.data.startDate | numberToDate}} - {{p.data.endDate | numberToDate}}
              </li>
              <li><strong> Fecha de creación:</strong> {{p.data.dateCreated |numberToDate}}</li>
              <li><strong> Dispersión máxima:</strong> {{p.data.dispersionMaxAmount |  currency:'':'$': '1.0-0'}}</li>
              <li><strong> Dispersión máxima por tarjeta:</strong>
                {{p.data.cardDispersionMaxAmount |  currency:'':'$': '1.0-0'}}</li>
            </ul>
          </div>
          <div class="mr-5">
            <h2>Costos de empresa</h2>
            <ul class="list-no-style">
              <li><strong> Setup de programa:</strong> {{p.data.companyCosts.programSetup |  currency:'':'$': '1.0-0'}}
              </li>
              <li><strong> Costo mensual:</strong> {{p.data.companyCosts.monthlyCost |  currency:'':'$': '1.0-0'}}</li>
              <li><strong> Costo x dispersión:</strong> {{p.data.companyCosts.dispersionCost |percent :'2.1'}}</li>
              <li><strong> Costo x creación de
                  tarjeta:</strong>{{p.data.companyCosts.cardCreation |  currency:'':'$': '1.0-0'}}</li>
              <li><strong> Costo anual de
                  programa:</strong>{{p.data.companyCosts.yearlyCost |  currency:'':'$': '1.0-0'}}</li>
              <li><strong> Costo x reemplazo de
                  tarjeta:</strong>{{p.data.companyCosts.cardReplacement |  currency:'':'$': '1.0-0'}}
              </li>
            </ul>
          </div>
          <div class="mr-5">
            <h2>Costos de usuario</h2>
            <ul class="list-no-style">
              <li><strong> Costo mensual:</strong> {{p.data.userCosts.monthlyCost |  currency:'':'$': '1.0-0'}}</li>
              <li><strong> Costo x creación de
                  tarjeta:</strong>{{p.data.userCosts.cardCreation |  currency:'':'$': '1.0-0'}}</li>
              <li><strong> Costo anual de
                  programa:</strong>{{p.data.userCosts.yearlyCost |  currency:'':'$': '1.0-0'}}</li>
              <li><strong> Costo x
                  transacción:</strong>{{p.data.userCosts.transactionCost |  currency:'':'$': '1.0-0'}}
              <li><strong> Costo x transferencia
                  virtual:</strong>{{p.data.userCosts.virtualWireingCost |  currency:'':'$': '1.0-0'}}
              <li><strong> Costo x transferencia
                  banncaria:</strong>{{p.data.userCosts.bankWireingCost |  currency:'':'$': '1.0-0'}}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div *dxTemplate="let btn of 'btnTemplate'">
        <dx-button icon="fas fa-pencil ico-sm" (onClick)="updateClient(btn.key)" class="brand-color"></dx-button>
      </div>
    </dx-data-grid>
  </div>
</div>